/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const localizationStrSchema = z
	.object({
		ru: z.string().optional(),
		en: z.string().optional(),
		es: z.string().optional(),
		ar: z.string().optional(),
		zh: z.string().optional(),
		kk: z.string().optional(),
		hy: z.string().optional(),
		ka: z.string().optional(),
		az: z.string().optional(),
		uz: z.string().optional(),
	})
	.describe("Util serializer for representation in swagger");
